import styled from "styled-components";
import AssetListCardCustomLoader from "modules/Common/Components/AssetListCardCutomLoader";

interface IAssetsListPlaceHolder {
  loading: boolean;
  isAssetsWithoutCampaign?: boolean;
  count?: boolean;
}

const AssetsListPlaceHolder = (props: IAssetsListPlaceHolder) => {
  const { loading, isAssetsWithoutCampaign, count } = props;
  return (
    <>
      {loading ? (
        <Wrapper>
          {[...Array.from(Array(count).keys(), (n) => n + 1)].map((item, index): any => (
            <div key={index} className={`responsive-svg type-1 ${isAssetsWithoutCampaign ? "border-2" : ""}`}>
              <AssetListCardCustomLoader isAssetWithoutCampaign={isAssetsWithoutCampaign} />
            </div>
          ))}
        </Wrapper>
      ) : null}
    </>
  );
};

export default AssetsListPlaceHolder;

AssetsListPlaceHolder.defaultProps = {
  count: 4,
};

const Wrapper = styled.div`
  .responsive-svg {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    overflow: hidden;
    position: relative;
    height: 100%;
    max-height: 280px;
    &:before {
      // background-image: url({XiQLightLogo});
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      left: 0;
      content: "";
      position: absolute;
      height: 63%;
      width: 100%;
      z-index: 99;
    }
    svg {
      width: 100%;
      height: 100%;
      defs {
        linearGradient {
          stop {
            stop-color: #e9e9e9 !important;
            &:nth-of-type(2) {
              stop-color: #f6f6f6 !important;
            }
          }
        }
      }
    }
    &.type-1 {
      height: 100%;
      width: 100%;
      margin-bottom: 5px;
      &:before {
        height: 230px;
      }
      .profile-img {
        height: 230px;
      }
      .title-m {
        margin-top: 21px;
      }
      &.type-1-3 {
        height: 294px;
        .profile-img {
          height: 170px;
        }
        .title-m {
          margin-top: 15px;
        }
        &:before {
          height: 170px;
          background-size: 90px;
        }
      }
      &.type-1-full {
        height: 420px;
        .profile-img {
          height: 295px;
        }
        &:before {
          height: 295px;
        }
        svg {
          height: 300px;
        }
      }
      svg {
        height: 350px;
        clipPath {
          rect {
            overflow: hidden;
            &:nth-child(1) {
              y: 90%;
              height: 5%;
              width: 30%;
            }
            &:nth-child(2) {
              y: 76%;
              height: 7%;
              width: 70%;
            }
            &:nth-child(3) {
              y: 65%;
              height: 7%;
              width: 80%;
            }
            &:nth-child(4) {
              height: 60%;
              width: 100%;
            }
          }
        }
      }
    }
    &.type-2 {
      height: auto;
      width: 100%;
      &:before {
        background-size: 40px;
        top: 15px;
        left: 10px;
        height: calc(100% - 30px);
        width: 100px;
      }
    }
    &.type-3 {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0px;
      height: auto;
      &:before {
        background-size: 60%;
        top: 15px;
        left: 0;
        height: calc(100% - 25px);
        width: 11%;
      }
    }
  }
  .small-three {
    height: 100%;
    flex-flow: column wrap;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
  }
  .border-2 {
    border: 2px solid #cbc2c2;
  }
`;
